import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitScheduleModel} from "../../../models/visit-schedule.model";
import {VisitScheduleOptimizationSettings} from "../../../models/visit-schedule-optimization-config.model";
import {VisitPlanFilterModel} from "../../../models/visit-plan-filter.model";

export const VisitPlanChannelActions = createActionGroup({
  source: '[VisitPlan/Channel]',
  events: {
    subscribe: emptyProps(),
    subscribePartial: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: VisitPlanModel }>(),
    partialNotificationReceived: props<{ notification: VisitPlanModel }>(),
  }
});

export const VisitPlanAPiActions = createActionGroup({
  source: '[VisitPlan/API]',
  events: {

    //Get VisitPlans
    getVisitPlans: props<{ filter?: VisitPlanFilterModel, params?: any, isSubscribeToChannel?: boolean }>(),
    getVisitPlansSuccess: props<{ visitPlans: VisitPlanModel[], isSubscribeToChannel?: boolean }>(),
    getVisitPlansFailure: props<{ error: any }>(),

    //Get VisitPlan
    getVisitPlan: props<{ visitPlanId: string, isSubscribeToChannel?: boolean }>(),
    getVisitPlanSuccess: props<{ visitPlan: VisitPlanModel, isSubscribeToChannel?: boolean }>(),
    getVisitPlanFailure: props<{ error: any }>(),

    //Delete Visit Plan
    deleteVisitPlan: props<{ visitPlanId: string; force: boolean }>(),
    deleteVisitPlanSuccess: props<{ visitPlanId: string }>(),
    deleteVisitPlanFailure: props<{ error: any }>(),

    //Restore Visit Plan
    restoreVisitPlan: props<{ visitPlanId: string }>(),
    restoreVisitPlanSuccess: props<{ visitPlanId: string }>(),
    restoreVisitPlanFailure: props<{ error: any }>(),


  }
});

export const VisitPlanActions = createActionGroup({
  source: '[VisitPlan]',
  events: {
    removeVisitPlans: props<{ ids: string[] }>(),
    removeVisitPlan: props<{ id: string }>(),
    setVisitPlans: props<{ visitPlans: VisitPlanModel[], isAppendFirst?: boolean, isSubscribeToChannel?: boolean }>(),
    setVisitPlan: props<{ visitPlan: VisitPlanModel, isAppendFirst?: boolean, isSubscribeToChannel?: boolean }>(),
    updateVisitPlan: props<{ visitPlan: VisitPlanModel }>(),
    updateVisitPlans: props<{ visitPlan: VisitPlanModel[] }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});

